export const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" fill="none">
    <g stroke="#fff" strokeLinecap="round" strokeWidth="3">
      <path d="M23.95 18.573 11.948 30.575M12 6.52l11.95 12.053" />
    </g>
  </svg>
);
